import { Moment } from 'moment';

import {
  HOTEL_SEARCH_DATE_FORMAT,
  SearchBarDateType,
  formatMomentDate,
} from '@utils/dateUtil';

export const formatDate = (date: SearchBarDateType | Moment | undefined) =>
  date ? formatMomentDate(date, HOTEL_SEARCH_DATE_FORMAT) : '';
